// extracted by mini-css-extract-plugin
export var iconContainer = "styles-module--iconContainer--3OBot";
export var iconSocial = "styles-module--iconSocial--17Lcs";
export var centeredIconContainer = "styles-module--centeredIconContainer--3mnPe";
export var iconContainerNonModal = "styles-module--iconContainerNonModal--ywoyG";
export var iconSocialNonModal = "styles-module--iconSocialNonModal--1F4_K";
export var centeredIconContainerNonModal = "styles-module--centeredIconContainerNonModal--1cmjP";
export var icon = "styles-module--icon--7EWqm";